import React, { useEffect } from "react";
import images from "../../../../utilities/images/images";
import "./OverallPage.scss";
import Performance from "./Performance/Performance";
import TimeQualityReport from "./TimeQualityReport/TimeQualityReport";
import PerformanceInsights from "../../components/sharedAnalytics/performanceInsights";
import { fetchOverallAnalyticsRequest } from "../../../../redux/exam_analytics/analyticsSlice";
import { useDispatch, useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";

const OverallPage = () => {
  const dispatch = useDispatch();

  // ⭐ Get paperId & paperType from examSlice
  const { testType, testDetails } = useSelector((s) => s.examSlice);

  const { overallAnalytics, loading } = useSelector((s) => s.analyticsSlice);

  useEffect(() => {
    // ⭐ Ensure they exist before calling API
    if (testDetails?.paper_id && testType?.id) {
      dispatch(
        fetchOverallAnalyticsRequest({
          paperId: testDetails.paper_id,
          paperType: testType.id,
          filter_by: "tpq",
        })
      );
    }
  }, [dispatch, testDetails, testType]);

  if (loading.overall) {
    return (
      <div className="overall__loading">
        <ClipLoader color="#C61C26" size={60} />
      </div>
    );
  }

  const analytics = overallAnalytics?.data;

  const scoreText = analytics
    ? `${analytics.user_marks}/${analytics.total_marks}`
    : "--";

  const percentageText = analytics ? `${analytics.percentage}%` : "--";

  const rank = analytics?.rank;
  const totalCandidates = analytics?.total_candidates;
  const accuracy = analytics?.accuracy;
  const percentile = analytics?.percentile;

  const performanceData = analytics?.performance_comparison || [];
  const zones = analytics?.time_quality_report?.zones || [];

  return (
    <div className="overall">
      {/* Metrics Header */}
      <div className="overall__metrics">
        <div className="overall__metrics__left">
          <img src={images.cupBiggerSize} alt="cup" />
          <div className="overall__metrics__left__rightwrapper">
            <div className="overall__metrics__left__score">{scoreText}</div>
            <div className="overall__metrics__left__percentage">
              {percentageText}
            </div>
          </div>
        </div>

        <div className="overall__metrics__right">
          <div className="overall__metrics__right__card">
            <div className="overall__metrics__right__card__value">#{rank}</div>
            <div className="overall__metrics__right__card__title">
              out of {totalCandidates}
            </div>
          </div>

          <div className="overall__metrics__right__card">
            <div className="overall__metrics__right__card__value">
              {accuracy}%
            </div>
            <div className="overall__metrics__right__card__title">Accuracy</div>
          </div>

          <div className="overall__metrics__right__card">
            <div className="overall__metrics__right__card__value">
              {percentile}%
            </div>
            <div className="overall__metrics__right__card__title">
              Percentile
            </div>
          </div>
        </div>
      </div>

      {/* Performance + Time Quality */}
      <div className="performance-time-container">
        <Performance performanceData={performanceData} />
        <TimeQualityReport zones={zones} />
      </div>

      {/* Insights */}
      <PerformanceInsights analytics={analytics} />
    </div>
  );
};

export default OverallPage;
